<template lang="pug">
  project-page(:uid="uid", @onEndTo="$emit('onEndTo', $event)")
</template>

<script>
import store from '@/store'
import ProjectPage from '@/components/Project/ProjectPage'
import { getNav, collectMedia } from '@/utils'
export default {
  name: 'Project',
  metaInfo () {
    const doc = this.doc
    if (!doc) return {}
    const title = [this.txt(doc.title), this.txt(doc.location)].filter(Boolean).join(', ')
    const desc = (this.txt(doc.summary) || '').replace(/\s+/g, ' ').trim().slice(0, 160)
    const first = collectMedia(doc).find(m => m.type === 'image')
    const meta = [
      { vmid: 'og:title', property: 'og:title', content: `${title} — Guido van Helten` },
      { vmid: 'og:type', property: 'og:type', content: 'article' }
    ]
    if (desc) {
      meta.push({ vmid: 'description', name: 'description', content: desc })
      meta.push({ vmid: 'og:description', property: 'og:description', content: desc })
    }
    if (first) meta.push({ vmid: 'og:image', property: 'og:image', content: first.id })
    return { title, meta }
  },
  props: ['uid', 'entering'],
  data () {
    return {
      txt: this.$prismic.richTextAsPlain
    }
  },
  computed: {
    doc () {
      const doc = this.$store.state.projects.find(doc => doc && doc.uid === this.uid)
      return doc && doc.data
    }
  },
  watch: {
    entering (enter) {
      // after enter jump to top
      return !enter && window.scroll(0, 0)
    }
  },
  beforeRouteEnter: (to, from, next) => getProject(to, from, next),
  beforeRouteUpdate: (to, from, next) => getProject(to, from, next),
  components: { ProjectPage }
}

const getProject = (to, from, next) => {
  store.commit('PROGRESS_START')
  Promise.all([
    store.dispatch('getProjects'),
    store.dispatch('getProject', to.params.uid)
  ])
    .then(([, doc]) => {
      if (!doc) {
        // not found
        store.commit('PROGRESS_FAIL')
        return next({ name: 'notfound' })
      }
      store.commit('PROGRESS_FINISH')
      const nav = doc.data && doc.data.scroll_nav_enabled !== 'hidden' && getNav(doc.data.body)
      store.commit('SET_NAV', nav)
      next()
    })
    .catch(e => {
      console.error(e)
      next({ name: 'error' })
    })
}
</script>
